import React, { useEffect } from "react";
import { Modal, ModalBody } from "reactstrap";
import { useForm } from "react-hook-form";
import NormalInput from "component/common/NormalInput/index";
import ErrorMessage from "component/common/ErrroMessage/index";
import SaveCancelBtn from "component/common/SaveCancelBtn";
import { Toast } from "utils/toast";
import { addInfluencer } from "service/Directory";
import usePopup from "hooks/usePopUp";
import close from "assets/images/close.svg";

import styles from "./AddInfluencer.module.scss";

const AddInfluencer = ({ isOpen, toggle }) => {
  const {
    handleSubmit,
    register,
    reset,
    formState: { errors },
  } = useForm();

  const { successPopUp, togglePopUp, setMsg } = usePopup();

  useEffect(() => {
    setMsg("Influencer has been added successfully");
  }, []);

  const onSubmit = async (data) => {
    try {
      let response = await addInfluencer(data);
      if (response.status == 200) {
        reset({
          influencerName: "",
          address: "",
          phoneNumber: "",
          notes: "",
          instagramHandle: "",
          numberOfFollowers: "",
        });
        toggle();
        togglePopUp();
      }
    } catch (error) {
      Toast({ type: "error", message: error.data.message });
    }
  };

  return (
    <>
      <Modal size="lg" isOpen={isOpen} toggle={toggle}>
        <ModalBody>
          <div className={styles.influencer_modal}>
            <div className={styles.close_icon} onClick={() => toggle()}>
              <img src={close} />
            </div>
            <div className={styles.influencer_title}>
              <b>ADD NEW INFLUENCER</b>
            </div>
            <div className={styles.influencer_content}>
              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "20px" }}>
                    <NormalInput
                      label="Influencer Name"
                      register={register("influencerName", {
                        required: true,
                        pattern: /^[A-Za-z ]+$/,
                        minLength: 3,
                      })}
                      error={errors.influencerName}
                    />
                    <ErrorMessage
                      error={errors.influencerName}
                      message={{
                        required: "Please enter influencer name",
                        minLength:
                          "Influencer name contain atleast 3 characters",
                        pattern: "Influencer name contain string only",
                      }}
                    />
                  </div>
                  <div style={{ marginBottom: "20px" }}>
                    <NormalInput
                      label="Phone Number"
                      register={register("phoneNumber", {
                        required: true,
                        pattern: /^[0-9]{10}$/,
                      })}
                      error={errors.phoneNumber}
                    />
                    <ErrorMessage
                      error={errors.phoneNumber}
                      message={{
                        required: "Please enter phone number",
                        pattern: "Phone number contain 10 numbers only",
                      }}
                    />
                  </div>
                  <div style={{ marginBottom: "20px" }}>
                    <NormalInput
                      label="Instagram Handle"
                      register={register("instagramHandle", { required: true })}
                      error={errors.instagramHandle}
                    />
                    <ErrorMessage
                      error={errors.instagramHandle}
                      message={{
                        required: "Please enter instagram handle",
                      }}
                    />
                  </div>
                  <div style={{ marginBottom: "20px" }}>
                    <NormalInput
                      label="Number of Followers"
                      register={register("numberOfFollowers", {
                        required: true,
                      })}
                      error={errors.numberOfFollowers}
                    />
                    <ErrorMessage
                      error={errors.numberOfFollowers}
                      message={{
                        required: "Please enter number of followers",
                      }}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className={styles.influencer_textarea}>
                    <label>Address</label>
                    <textarea
                      {...register("address", { required: true, minLength: 3 })}
                      style={{
                        borderColor: errors.address ? "#f90500" : "#c4c4c4",
                      }}
                    />
                    <ErrorMessage
                      error={errors.address}
                      message={{
                        required: "Please enter address",
                        minLength: "Address contain atleast 3 characters",
                      }}
                    />
                  </div>
                  <div className={styles.influencer_textarea}>
                    <label>Notes</label>
                    <textarea
                      {...register("notes", { required: true })}
                      style={{
                        borderColor: errors.notes ? "#f90500" : "#c4c4c4",
                      }}
                    />
                    <ErrorMessage
                      error={errors.notes}
                      message={{
                        required: "Please enter notes",
                      }}
                    />
                  </div>
                </div>
              </div>
              <SaveCancelBtn
                position="center"
                onCancel={toggle}
                onSave={handleSubmit(onSubmit)}
              />
            </div>
          </div>
        </ModalBody>
      </Modal>
      {successPopUp()}
    </>
  );
};

export default AddInfluencer;
